import { ReactNode } from "react";
import Widget from "../../../commons/base/widget";
import FormButton from "../../../commons/ui/form_button";
import WasteViewModel from "../view_models/waste_view_model";
import WasteScreen from "../waste_screen";
import WasteScreenState from "../view_models/waste_state";

export default class LocationSelection extends Widget<{}, WasteScreenState, WasteViewModel, WasteScreen> {
    
    onButtonClick(locationId: number, locationName: string) {
        this.viewModel.emit((lastState) => {
            lastState.selectedLocationId = locationId;
            lastState.selectedLocation = locationName;
            return lastState;
        })
    }

    render(): ReactNode {
        return (
            <>
            {
                this.vmState.wasteLocations && this.vmState.wasteLocations.length > 0
                ? this.vmState.wasteLocations.map((loc, index) => {
                    return (
                        <div style={{display: "inline-block", margin: 10}} key={index}>
                            <FormButton
                            action={(e) => {
                                e.preventDefault();
                                this.onButtonClick(loc.locationId, loc.locationName)
                            }}
                            title={loc.locationName}
                            backgroundColor="#58BAD7"
                            textColor="#FFF"/>
                        </div>
                    )
                })
                : (
                    <FormButton
                        action={() => {}}
                        title="Tidak Ada Riwayat Dalam 7 Hari Terakhir"
                        backgroundColor="#58BAD7"
                        textColor="#FFF"/>
                )
            }   
            </>  
        )
    }
}